export default {
  isCrossTenantSession: (state) => state.crossTenantSession,
  isCrossTenantSessionHost: (state) => state.crossTenantSessionHost
};
